import { reactProps } from "../../types";

interface props extends reactProps {
  label?: string;
}
const Jhevbutton = ({ label, onClick, style, className, children }: props) => {
  const buttonStyle = {
    cursor: "pointer",
    fontWeight: 700,
    transition: "all 0.2s",
    padding: "6px 16px",
    borderRadius: "5px",
    background:
      "linear-gradient( 95.69deg, #ac0000 0, #f00 26.35%, #ff3b3b 50.83%, #f00 72.71%, #f00 100% )",
    color: "#fff",
    border: "1px solid transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "15px",
  };

  return (
    <p
      style={{ ...buttonStyle, ...style }}
      onClick={onClick}
      className={className}
    >
      {label || children}
    </p>
  );
};

export default Jhevbutton;
